import React, { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import CanvasDraw from "react-canvas-draw";
import qs from 'query-string'

import Btn from '../../components/Buttons/SaveButton'
import { NumFormat } from '../../components/TextInput'

import { req, resourceUrl, damageType, sides, isAllowed, CAR_FORM_V2, SNAP_V2 } from '../../util'

import { toggleLoading } from '../../redux/actions'

import { compressToUTF16, decompressFromUTF16 } from 'lz-string'


export const Sketch = ({ location }) => {

    const history = useHistory()
    const dispatch = useDispatch()
    const canvasRef = useRef()
    const [color, setColor] = useState(damageType.paint.color)
    const [car, setCar] = useState(null)
    const [currentSide, setCurrentSide] = useState(1)
    const [brushRaduis, setBrushRaduis] = useState(7)
    const user = useSelector(state => state.user.user)

    const undo = () => {
        if (!canvasRef.current) return
        canvasRef.current.undo()
    }

    const clear = () => {
        if (!canvasRef.current || !window.confirm("هل انت متاكد من حذف التأشيرات ?")) return
        canvasRef.current.clear()
    }


    const setPencilColor = (type) => {
        setColor(type)
    }

    const getCar = (id) => {
        dispatch(toggleLoading())
        req("GET", `car?id=${id}`).then(r => {
            let { success, data, err } = r
            if (!success) throw err
            let { imgs } = data;
            Object.keys(sides).forEach(k => localStorage.setItem(k, imgs[k] ? decompressFromUTF16(imgs[k]) : ""))
            setCar({ ...data })
            dispatch(toggleLoading())
        }).catch(e => {
            console.error(e)
            dispatch(toggleLoading())
            alert("لا يوجد اتصال بالخادم")
        })
    }

    useEffect(() => {
        let { id } = qs.parse(window.location.search)
        if (!location.state && !id) history.replace("/")
        let c = { id: id || location?.state?.id }
        getCar(c.id)
    }, [location.state, history])

    useEffect(() => {
        if (!canvasRef.current) return
        canvasRef.current.clear()
        canvasRef.current.drawImage()
        canvasRef.current.loadSaveData(localStorage.getItem(`side${currentSide}`))
    }, [currentSide])


    const nextSide = () => {
        dispatch(toggleLoading())
        setCurrentSide(s => s + 1)
        setTimeout(() => dispatch(toggleLoading()), 500)
    }

    const pervSide = () => {
        dispatch(toggleLoading())
        setCurrentSide(s => s - 1)
        setTimeout(() => dispatch(toggleLoading()), 500)
    }

    const saveCurrentCanvas = () => {
        localStorage.setItem(`side${currentSide}`, canvasRef.current.getSaveData())
    }

    const submit = async () => {
        let sideObj = {}
        Object.keys(sides).forEach(k => sideObj[k] = localStorage.getItem(k) ? compressToUTF16(localStorage.getItem(k)) : "")
        try {
            dispatch(toggleLoading())
            let { success } = await req("POST", "car/img", { carID: car.id, ...sideObj })
            if (success) {
                history.replace("/scan")
            }
            dispatch(toggleLoading())
        } catch (err) {
            dispatch(toggleLoading())
            alert("لا يوجد اتصال بالخادم")
        }
    }

    const snap = async () => {
        try {
            if (!window.confirm("هل انت متاكد ان العجلة جاهزة للتصوير ؟")) return
            dispatch(toggleLoading())
            let { success } = await req("GET", `http://${window.location.hostname}:8080/snap?carID=${car.id}`)
            dispatch(toggleLoading())
            if (!success) {
                return alert("حصل خطأ في التقاط الصور")
            }
            history.go(0)
        } catch (err) {
            dispatch(toggleLoading())
            alert("لا يوجد اتصال بالخادم")
        }
    }


    const snapV2 = async () => {
        try {
            if (!window.confirm("هل انت متاكد ان العجلة جاهزة للتصوير ؟")) return
            dispatch(toggleLoading())
            let { success } = await req("GET", `http://${window.location.hostname}:8081/v2/snap?carID=${car.id}`)
            dispatch(toggleLoading())
            if (!success) {
                return alert("حصل خطأ في التقاط الصور")
            }
            history.go(0)
        } catch (err) {
            dispatch(toggleLoading())
            alert("لا يوجد اتصال بالخادم")
        }
    }

    const archScan = async () => {
        if (!window.confirm('هل انت متاكد من فحص العجلة باستخدام القوس ؟ يجب التاكد من خلو المكان !!')) return
        try {
            dispatch(toggleLoading())
            let { success } = await req("GET", `arch/move?carID=${car.id}`)
            dispatch(toggleLoading())
            if (!success) {
                return alert("حصل خطأ في التقاط الصور")
            }
            history.go(0)
        } catch (err) {
            dispatch(toggleLoading())
            alert("لا يوجد اتصال بالخادم")
        }
    }

    useEffect(() => {
        return () => Object.keys(sides).forEach(k => localStorage.removeItem(k))
    }, [])

    return (
        <div className="container mx-auto p-4">
            {car &&
                <>
                    <div className="text-center text-xl font-normal text-gray-800 my-2">فحص العجلات</div>
                    <div className="text-center text-lg font-semibold text-gray-800">{car.brand} {car.model} {car.year}</div>
                    <div className="flex justify-between m-4">
                        <button className="bg-blue-500 text-white px-2 py-1 shadow-md rounded-md" disabled={currentSide >= 5} onClick={nextSide}>التالي</button>
                        <div className="text-xl font-normal ">{sides[`side${currentSide}`]}</div>
                        <button className="bg-blue-500 text-white px-2 py-1 shadow-md rounded-md" disabled={currentSide <= 1} onClick={pervSide}>السابق</button>
                    </div>
                    <div className="flex justify-center">
                        <CanvasDraw
                            ref={canvasRef}
                            hideGrid={true}
                            lazyRadius={0}
                            brushRadius={brushRaduis}
                            brushColor={color}
                            canvasWidth="720px"
                            loadTimeOffset={0}
                            backgroundColor="#cbd5e0"
                            imgSrc={`${resourceUrl}/api/img/${car[`side${currentSide}`]}?auth=${localStorage.getItem("token")}`}
                            saveData={localStorage.getItem(`side${currentSide}`) || ""}
                            immediateLoading
                        />
                    </div>
                    <div className="flex items-center justify-center my-4">
                        <div>حجم الفرشا :</div>
                        <div>
                            <NumFormat value={brushRaduis} onValueChange={({ floatValue }) => setBrushRaduis(floatValue)} />
                        </div>
                    </div>
                    <div className="flex flex-wrap justify-center mx-4">
                        <div className="w-1/2 md:w-1/3"><Btn bgColor={true} text="رجوع" onClick={undo} /></div>
                        <div className="w-1/2 md:w-1/3"><Btn bgColor={true} text="تفريغ" onClick={clear} /></div>
                        <div className="w-1/2 md:w-1/3"><Btn bgColor={true} text="حفظ" onClick={saveCurrentCanvas} /></div>
                        {
                            Object.keys(damageType).map(d =>
                                <div className="w-1/2 md:w-1/3 lg:w-1/4" key={d}>
                                    <Btn text={damageType[d].title} onClick={() => setPencilColor(damageType[d].color)} bgColor={damageType[d].color} />
                                </div>
                            )
                        }
                    </div>
                    <div className="flex justify-center">
                        <div className="w-1/2 md:w-1/3">
                            <Btn bgColor={true} text="ارسال التقرير" onClick={submit} />
                        </div>

                        <div className="w-1/2 md:w-1/3">
                            <Btn bgColor={true} text="التقاط الصور" onClick={snap} />
                        </div>

                        {isAllowed(user, [SNAP_V2]) &&
                            <div className="w-1/2 md:w-1/3">
                                <Btn bgColor={true} text="التقاط صور مفرغة" onClick={snapV2} />
                            </div>
                        }
                    </div>
                </>
            }
        </div>
    )
}